import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpBrands = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated() {

    },
    mounted() {
        let mpSwiperBrands = new Swiper($(this.$el).find('.js-brands-slider')[0], {
            loop: true,
            lazyPreloadPrevNext: 2, // соседи видимых: Swiper снимает loading у их картинок — сигнал модулю lazyload.js
            grabCursor: true,
            slidesPerView: 8,
            spaceBetween: 15,
            autoplay: {
                delay: 3000
            },
            navigation: {
                nextEl: ".js-brands-next",
                prevEl: ".js-brands-prev"
            },
            breakpoints: {
                320: {
                    slidesPerView: 3.45,
                    spaceBetween: 5
                },
                440: {
                    slidesPerView: 5,
                    spaceBetween: 5
                },
                768: {
                    slidesPerView: 6,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: 8,
                    spaceBetween: 15
                }
            }
        });
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="mp-brands">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Бренды
                </h2>
                <div class="section__nav-arrows">
                    <div class="swiper-button-prev slider-btn js-brands-prev">
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                    </div>
                    <div class="swiper-button-next slider-btn js-brands-next">
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                </div>
            </div>
            <div class="section__nav"><a :href="this.struct[this.structKey].componentData.ALL_PAGE" class="section__nav-link"> Все <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg></a></div>
        </div>
        <div class="swiper clients__slider js-brands-slider">
            <div class="swiper-wrapper">
                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="swiper-slide">
                    <div class="clients__slide">
                        <a :href="item.LINK" class="clients__card" :class="{'no-photo': item.PICTURE == null}">
                            <img v-if="item.PICTURE" class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME" loading="lazy">
                            <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    `
}